module.exports = __webpack_public_path__ + "static/media/bufyremera.e0a07d4b.webp";